export default "__VITE_ASSET__B5707Jr9__"